import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Json2Pipe } from './json2.pipe';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'messenger',
  templateUrl: './messenger-component.html',
  styleUrl: './messenger-component.scss',
  standalone: true,
  imports: [Json2Pipe, MatButtonModule, MatDialogModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessengerComponent {
  readonly data;
  readonly message;

  constructor(@Inject(MAT_DIALOG_DATA) data: unknown) {
    this.data = data;
    this.message =
      typeof data === 'object' && data !== null && 'message' in data
        ? data.message
        : typeof data === 'string'
        ? data
        : null;
  }
}
